import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="user-toggle"
export default class extends Controller {
  static targets = ["field", "toggleable"]
  initialize() {
    this.toggleFields = {}
  }

  fieldTargetConnected(field) {
    const fieldName = field.dataset.userTogglesFieldValue
    this.toggleFields[fieldName] = JSON.parse(field.dataset.userTogglesValuesValue)
    // field.remove();
    this.updateUI()
  }

  updateUI() {
    this.toggleableTargets.forEach(toggleable => {
      const field = toggleable.dataset.userTogglesField
      const values = this.toggleFields[field]
      if (!values) return

      const showIfSearch = toggleable.dataset.userTogglesShowIf
      if (showIfSearch) {
        toggleable.classList.toggle("hidden", !values.includes(showIfSearch))
      }

      const hideIfSearch = toggleable.dataset.userTogglesHideIf
      if (hideIfSearch) {
        toggleable.classList.toggle("hidden", values.includes(hideIfSearch))
      }
   })
  }
}
